<template>
  <section class="forbidden-wrap">
    <div class="glow glow-left" aria-hidden="true"></div>
    <div class="glow glow-right" aria-hidden="true"></div>

    <article class="forbidden-card" role="alert" aria-live="polite">
      <p class="status-badge">ERROR 403</p>

      <div class="title-row">
        <span class="lock-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <path
              d="M17 9h-1V7a4 4 0 0 0-8 0v2H7a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2Zm-6.5-2a1.5 1.5 0 0 1 3 0v2h-3V7Zm2.5 9.73V18a1 1 0 1 1-2 0v-1.27a2 2 0 1 1 2 0Z"
            />
          </svg>
        </span>
        <h1>접근이 거부되었습니다</h1>
      </div>

      <p class="description">
        현재 계정에는 이 페이지를 볼 권한이 없습니다.
        필요한 권한이 있다고 판단되면 관리자에게 요청해 주세요.
      </p>

      <div class="actions">
        <router-link to="/" class="btn btn-primary">대시보드로 이동</router-link>
        <button type="button" class="btn btn-secondary" @click="goBack">이전 페이지</button>
      </div>
    </article>
  </section>
</template>

<script setup>
const goBack = () => {
  if (window.history.length > 1) {
    window.history.back();
    return;
  }
  window.location.href = "/";
};
</script>

<style scoped>
.forbidden-wrap {
  --bg-top: #f7fbff;
  --bg-bottom: #eaf2ff;
  --card-bg: #ffffff;
  --title: #132748;
  --body: #4d5b73;
  --line: #d9e3f2;
  --primary: #184b9a;
  --primary-hover: #123b7b;
  --secondary-bg: #eef3fb;
  --secondary-text: #2e4768;

  position: relative;
  min-height: calc(100vh - 170px);
  display: grid;
  place-items: center;
  padding: 32px 16px;
  background: linear-gradient(160deg, var(--bg-top) 0%, var(--bg-bottom) 100%);
  overflow: hidden;
}

.glow {
  position: absolute;
  border-radius: 999px;
  filter: blur(2px);
  opacity: 0.28;
  pointer-events: none;
}

.glow-left {
  width: 280px;
  height: 280px;
  left: -90px;
  top: -80px;
  background: radial-gradient(circle, #73a7ff 0%, rgba(115, 167, 255, 0) 70%);
}

.glow-right {
  width: 340px;
  height: 340px;
  right: -120px;
  bottom: -120px;
  background: radial-gradient(circle, #9cc2ff 0%, rgba(156, 194, 255, 0) 70%);
}

.forbidden-card {
  width: 100%;
  max-width: 720px;
  background: var(--card-bg);
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 34px 30px;
  box-shadow: 0 22px 45px rgba(15, 42, 82, 0.12);
  position: relative;
  z-index: 1;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  margin: 0 0 14px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #204f9d;
  background: #e6efff;
}

.title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.lock-icon {
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #edf3ff;
}

.lock-icon svg {
  width: 22px;
  height: 22px;
  fill: #1f4c97;
}

h1 {
  margin: 0;
  color: var(--title);
  font-size: clamp(22px, 2.8vw, 30px);
  line-height: 1.25;
  letter-spacing: -0.02em;
}

.description {
  margin: 0;
  color: var(--body);
  font-size: 15px;
  line-height: 1.7;
  max-width: 560px;
}

.actions {
  margin-top: 26px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.btn {
  border: 0;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.12s ease, box-shadow 0.12s ease, background-color 0.12s ease;
}

.btn:hover {
  transform: translateY(-1px);
}

.btn-primary {
  color: #fff;
  background: var(--primary);
  box-shadow: 0 8px 16px rgba(24, 75, 154, 0.25);
}

.btn-primary:hover {
  background: var(--primary-hover);
}

.btn-secondary {
  color: var(--secondary-text);
  background: var(--secondary-bg);
}

.btn-secondary:hover {
  background: #e2ebf8;
}

@media (max-width: 640px) {
  .forbidden-wrap {
    min-height: calc(100vh - 150px);
    padding: 20px 12px;
  }

  .forbidden-card {
    border-radius: 14px;
    padding: 24px 18px;
  }

  .title-row {
    align-items: flex-start;
    gap: 10px;
  }

  .actions {
    flex-direction: column;
  }

  .btn {
    width: 100%;
    text-align: center;
  }
}
</style>
